var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14 8.49996V9.83329M8 4.49996H4C2.89543 4.49996 2 5.39539 2 6.49996V9.83329M2 9.83329V11.1666C2 12.2712 2.89543 13.1666 4 13.1666H12C13.1046 13.1666 14 12.2712 14 11.1666V9.83329M2 9.83329H14M15.3333 3.16663L12 6.49996L10.6667 5.16663",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardCheck);
export default __webpack_public_path__ + "static/media/credit-card-check.d255dbe4d2ee30c99c16cecbecf226bf.svg";
export { ForwardRef as ReactComponent };